module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/icon-badge-01-a4eee27d2220b15862d6d00a8e24d3dd.svg";